import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_Asam = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_Asam' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'><h1>Demographic information</h1></p>

                <table>
                    <tr>
                        <td className='w-300'><span className='eleHeader'>Okay to leave voicemail?</span></td>
                        <td className='w-150'><span className='eleHeader'>Age</span></td>
                        <td className='w-300'><span className='eleHeader'>Preferred Language</span></td>
                    </tr>

                    <tr>
                        <td className='w-300'>
                            <input type='radio' id='rbOkeyVoicemailYes' name='rbOkeyVoicemail' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbOkeyVoicemailNo' name='rbOkeyVoicemail' className='add-only' value='No' /> No
                        </td>
                        <td className='w-150'><input type='text' id='txtDemographicAge' name='txtDemographicAge' className='add-only' /></td>
                        <td className='w-300'><input type='text' id='txtDemographicPreferredLanguage' name='txtDemographicPreferredLanguage' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Insurance Type</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='radio' id='rbInsuranceTypeNone' name='rbInsuranceType' className='add-only' value='None' /> None</td>
                        <td className='w-150'><input type='radio' id='rbInsuranceTypeMedicare' name='rbInsuranceType' className='add-only' value='Medicare' /> Medicare (Plan)</td>
                        <td className='w-150'><input type='radio' id='rbInsuranceTypeMco' name='rbInsuranceType' className='add-only' value='Mco' /> MCO (Plan)</td>
                        <td className='w-150'><input type='radio' id='rbInsuranceTypeMedicaid' name='rbInsuranceType' className='add-only' value='Medicaid' /> Medicaid</td>
                        <td className='w-150'><input type='radio' id='rbInsuranceTypePrivate' name='rbInsuranceType' className='add-only' value='Private' /> Private (Plan)</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='radio' id='rbInsuranceTypeOther' name='rbInsuranceType' className='add-only' value='None' /> Other (Plan):
                            <input type='text' id='txtInsuranceTypeOther' name='txtInsuranceTypeOther' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>



                    <tr>
                        <td className='w-750'><span className='eleHeader'>Living Arrangement</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='radio' id='rbLivingArrangementHomeless' name='rbLivingArrangement' className='add-only' value='Homeless' /> Homeless</td>
                        <td className='w-150'><input type='radio' id='rbLivingArrangementIndependentLiving' name='rbLivingArrangement' className='add-only' value='IndependentLiving' /> Independent Living</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='radio' id='rbLivingArrangementOther' name='rbLivingArrangement' className='add-only' value='Other' /> Other (specify):
                            <input type='text' id='txtLivingArrangementOther' name='txtLivingArrangementOther' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Referred by (specify)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtReferredBy' name='txtReferredBy' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Explanation of why patient is currently seeking treatment</span>
                            <span className='small'>Current symptoms, functional impairment, severity, duration of symptoms (e.g., unable to work/school, relationship/housing problems)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtWhySeekingTreatment' name='txtWhySeekingTreatment' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><h2>Dimension 1: Substance Use, Acute Intoxication and/or Withdrawal Potential</h2></p>
                <p className='w-750'><h3>1.Substance use history</h3></p>
                

                <table>
                    <tr>
                        <td className='w-120'><span className='eleHeader'>Alcohol and/or Drug Types</span></td>
                        <td className='w-70'><span className='eleHeader'>Recently Used?<span className='small'>(Past 6 Months)</span></span></td>
                        <td className='w-70'><span className='eleHeader'>Prior Use?<span className='small'>(Lifetime)</span></span></td>
                        <td className='w-110'><span className='eleHeader'>Route<span className='small'>(Inject,Smoke, <br />Snort)</span></span></td>
                        <td className='w-100'><span className='eleHeader'>Frequency<span className='small'>(Daily,Weekly, <br />Monthly)</span></span></td>
                        <td className='w-130'><span className='eleHeader'>Duration<span className='small'>(Length of Use)</span></span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last Use</span></td>
                    </tr>


                    <tr>
                        <td className='w-120'>
                            Amphetamines <span className='small'>(Meth, Ice, Crank)</span>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_1Months' name='rbrbAlcohoType_1' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_1Lifetime' name='rbrbAlcohoType_1' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_1Route_1' name='txtAlcohoType_1Route_1' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_1Frequency_1' name='txtAlcohoType_1Frequency_1' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_1Duration_1' name='txtAlcohoType_1Duration_1' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_1Date_1' name='txtAlcohoType_1Date_1' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Alcohol</td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_2Months' name='rbrbAlcohoType_2' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_2Lifetime' name='rbrbAlcohoType_2' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_2Route_2' name='txtAlcohoType_2Route_2' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_2Frequency_2' name='txtAlcohoType_2Frequency_2' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_2Duration_2' name='txtAlcohoType_2Duration_2' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_2Date_2' name='txtAlcohoType_2Date_2' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Cocaine/Crack</td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_3Months' name='rbrbAlcohoType_3' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_3Lifetime' name='rbrbAlcohoType_3' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_3Route_3' name='txtAlcohoType_3Route_3' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_3Frequency_3' name='txtAlcohoType_3Frequency_3' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_3Duration_3' name='txtAlcohoType_3Duration_3' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_3Date_3' name='txtAlcohoType_3Date_3' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Heroin</td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_4Months' name='rbrbAlcohoType_4' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_4Lifetime' name='rbrbAlcohoType_4' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_4Route_4' name='txtAlcohoType_4Route_4' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_4Frequency_4' name='txtAlcohoType_4Frequency_4' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_4Duration_4' name='txtAlcohoType_4Duration_4' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_4Date_4' name='txtAlcohoType_4Date_4' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Marijuana</td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_5Months' name='rbrbAlcohoType_5' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_5Lifetime' name='rbrbAlcohoType_5' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_5Route_5' name='txtAlcohoType_5Route_5' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_5Frequency_5' name='txtAlcohoType_5Frequency_5' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_5Duration_5' name='txtAlcohoType_5Duration_5' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_5Date_5' name='txtAlcohoType_5Date_5' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Opioid Pain Medications <span className='small'>Misuse or without prescription</span></td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_6Months' name='rbrbAlcohoType_6' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_6Lifetime' name='rbrbAlcohoType_6' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_6Route_6' name='txtAlcohoType_6Route_6' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_6Frequency_6' name='txtAlcohoType_6Frequency_6' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_6Duration_6' name='txtAlcohoType_6Duration_6' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_6Date_6' name='txtAlcohoType_6Date_6' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Sedatives <span className='small'>(Benzos, Sleeping Pills) <br />Misuse or without prescription</span></td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_7Months' name='rbrbAlcohoType_7' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_7Lifetime' name='rbrbAlcohoType_7' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_7Route_7' name='txtAlcohoType_7Route_7' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_7Frequency_7' name='txtAlcohoType_7Frequency_7' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_7Duration_7' name='txtAlcohoType_7Duration_7' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_7Date_7' name='txtAlcohoType_7Date_7' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Hallucinogens</td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_8Months' name='rbrbAlcohoType_8' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_8Lifetime' name='rbrbAlcohoType_8' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_8Route_8' name='txtAlcohoType_8Route_8' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_8Frequency_8' name='txtAlcohoType_8Frequency_8' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_8Duration_8' name='txtAlcohoType_8Duration_8' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_8Date_8' name='txtAlcohoType_8Date_8' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Inhalants</td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_9Months' name='rbrbAlcohoType_9' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_9Lifetime' name='rbrbAlcohoType_9' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_9Route_9' name='txtAlcohoType_9Route_9' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_9Frequency_9' name='txtAlcohoType_9Frequency_9' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_9Duration_9' name='txtAlcohoType_9Duration_9' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_9Date_9' name='txtAlcohoType_9Date_9' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Over-the-Counter Medications <span className='small'>(Cough Syrup, Diet Aids)</span></td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_10Months' name='rbrbAlcohoType_10' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_10Lifetime' name='rbrbAlcohoType_10' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_10Route_10' name='txtAlcohoType_10Route_10' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_10Frequency_10' name='txtAlcohoType_10Frequency_10' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_10Duration_10' name='txtAlcohoType_10Duration_10' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_10Date_10' name='txtAlcohoType_10Date_10' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Nicotine</td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_11Months' name='rbrbAlcohoType_11' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_11Lifetime' name='rbrbAlcohoType_11' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_11Route_11' name='txtAlcohoType_11Route_11' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_11Frequency_11' name='txtAlcohoType_11Frequency_11' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_11Duration_11' name='txtAlcohoType_11Duration_11' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_11Date_11' name='txtAlcohoType_11Date_11' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>


                    <tr>
                        <td className='w-120'>Other: <input type='text' id='txtAlcohoType_1Other_1' name='txtAlcohoType_1Other_1' className='add-only w-120 custom-add-only' /></td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_12Months' name='rbrbAlcohoType_12' value='6_Months' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='radio' id='rbAlcohoType_12Lifetime' name='rbrbAlcohoType_12' value='Lifetime' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohoType_12Route_12' name='txtAlcohoType_12Route_12' className='add-only w-110 custom-add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAlcohoType_12Frequency_12' name='txtAlcohoType_12Frequency_12' className='add-only w-100 custom-add-only' />
                        </td>
                        <td className='w-130'>
                            <input type='text' id='txtAlcohoType_12Duration_12' name='txtAlcohoType_12Duration_12' className='add-only w-130 custom-add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohoType_12Date_12' name='txtAlcohoType_12Date_12' className='add-only w-150 custom-add-only' />
                        </td>
                    </tr>

                    
                </table>

                <p className='w-750'><span className='eleHeader'>Additional Information</span></p>
                <p className='w-750'>
                    <textarea id='txtSubstanceHistoryAdditionalInfo' name='txtSubstanceHistoryAdditionalInfo' className='add-only' ></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>2. Do you find yourself using more alcohol and/or drugs than you intend to?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMoreDrugsThenIntendedYes' name='rbMoreDrugsThenIntended' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMoreDrugsThenIntendedNo' name='rbMoreDrugsThenIntended' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe:
                            <input type='text' id='txtMoreDrugsThenIntendedDescribe' name='txtMoreDrugsThenIntendedDescribe' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>3. Do you get physically ill when you stop using alcohol and/or drugs?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbPhysicallyIllYes' name='rbPhysicallyIll' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPhysicallyIllNo' name='rbPhysicallyIll' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe:
                            <input type='text' id='txtPhysicallyIllDescribe' name='txtPhysicallyIllDescribe' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>4. Are you currently experiencing withdrawal symptoms, such as tremors, excessive sweating, rapid heart rate,blackouts, anxiety, vomiting, etc.?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWithdrawalSymptomsYes' name='rbWithdrawalSymptoms' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWithdrawalSymptomsNo' name='rbWithdrawalSymptoms' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe specific symptoms and consider immediate referral for medical evaluation:
                            <input type='text' id='txtWithdrawalSymptomsDescribe' name='txtWithdrawalSymptomsDescribe' className='add-only w-500 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>5. Do you have a history of serious withdrawal, seizures, or life-threatening symptoms during withdrawal?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbLifetreateningSymptomsYes' name='rbLifetreateningSymptoms' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLifetreateningSymptomsNo' name='rbLifetreateningSymptoms' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe and specify withdrawal substance(s):

                            <input type='text' id='txtLifetreateningSymptomsDescribe' name='txtLifetreateningSymptomsDescribe' className='add-only w-500 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>6. Do you find yourself using more alcohol and/or drugs in order to get the same high?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSameHighYes' name='rbSameHigh' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSameHighNo' name='rbSameHigh' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe:
                            <input type='text' id='txtSameHighDescribe' name='txtSameHighDescribe' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>7. Has your alcohol and/or drug use changed recently (increase/ decreased, changed route of use)?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDrugUseChangedYes' name='rbDrugUseChanged' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDrugUseChangedNo' name='rbDrugUseChanged' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe:
                            <input type='text' id='txtDrugUseChangedDescribe' name='txtDrugUseChangedDescribe' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>8. Please describe family history of alcohol and/or drug use</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDrugUseFamilyHistoryYes' name='rbDrugUseFamilyHistory' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDrugUseFamilyHistoryNo' name='rbDrugUseFamilyHistory' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>Please circle one of the following levels of severity</p>

                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Severity Rating- Dimension 1 (Substance Use, Acute Intoxication and/or Withdrawal Potential)</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'> 0 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension1_0' name='rbSeverityRatingDimension1' className='add-only' value='None' /><b> None
                                <span className='small'>No signs of withdrawal/intoxication present</span></b>
                        </td>
                        <td className='w-150'> 1 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension1_1' name='rbSeverityRatingDimension1' className='add-only' value='Mild' /><b> Mild
                                <span className='small'>Mild/moderate intoxication, interferers with daily functioning. Minimal risk of severe withdrawal. No danger to self/others.</span></b>
                        </td>
                        <td className='w-150'> 2 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension1_2' name='rbSeverityRatingDimension1' className='add-only' value='Moderate' /><b> Moderate
                                <span className='small'>May have severe intoxication but responds to support. Moderate risk of severe withdrawal. No danger to self/others.</span></b>
                        </td>
                        <td className='w-150'> 3 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension1_3' name='rbSeverityRatingDimension1' className='add-only' value='Severe' /><b> Severe
                                <span className='small'>Severe intoxication with imminent risk of danger to self/others. Risk of severe manageable withdrawal.</span></b>
                        </td>
                        <td className='w-150'> 4 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension1_4' name='rbSeverityRatingDimension1' className='add-only' value='VerySevere' /><b> Very Severe
                                <span className='small'>ncapacitated. Severe signs and symptoms. Presents danger, i.e. seizures. Continued substance use poses an imminent threat to life.</span></b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Additional Comment</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSeverityRatingDimension1AdditionalInformation' name='txtSeverityRatingDimension1AdditionalInformation' className='add-only' /></td>
                    </tr>

                </table>

                
                

                <p className='w-750'><h2>Dimension 2: Biomedical Conditions and Complications</h2></p>
                <p className='w-750'><h3>9. Please list known medical provider(s)</h3></p>

                <table>
                    <tr>
                        <td className='w-300'><span className='eleHeader'>Physician Name</span></td>
                        <td className='w-250'><span className='eleHeader'>Specialty</span></td>
                        <td className='w-200'><span className='eleHeader'>Contact Information</span></td>
                    </tr>

                    <tr>
                        <td className='w-300'><input type='text' id='txtPhysicalName_1' name='txtPhysicalName_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSpeciality_1' name='txtSpeciality_1' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtContactInformation_1' name='txtContactInformation_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><input type='text' id='txtPhysicalName_2' name='txtPhysicalName_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSpeciality_2' name='txtSpeciality_2' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtContactInformation_2' name='txtContactInformation_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><input type='text' id='txtPhysicalName_3' name='txtPhysicalName_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSpeciality_3' name='txtSpeciality_3' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtContactInformation_3' name='txtContactInformation_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-300'><input type='text' id='txtPhysicalName_4' name='txtPhysicalName_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' id='txtSpeciality_4' name='txtSpeciality_4' className='add-only' /></td>
                        <td className='w-200'><input type='text' id='txtContactInformation_4' name='txtContactInformation_4' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>10. Do you have any of the following medical conditions</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHeartProblems' name='cbHeartProblems' className='add-only' value='HeartProblems' />Heart Problems </td>
                        <td className='w-250'><input type='checkbox' id='cbNeurological' name='cbNeurological' className='add-only' value='SeizureNeurological' />Seizure/Neurological </td>
                        <td className='w-250'><input type='checkbox' id='cbJointProblems' name='cbJointProblems' className='add-only' value='MuscleJointProblems' />Muscle/Joint Problems </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDiabetes' name='cbDiabetes' className='add-only' value='Diabetes' />Diabetes </td>
                        <td className='w-250'><input type='checkbox' id='cbHighBloodPressure' name='cbHighBloodPressure' className='add-only' value='HighBloodPressure' />High Blood Pressure </td>
                        <td className='w-250'><input type='checkbox' id='cbThyroidProblems' name='cbThyroidProblems' className='add-only' value='ThyroidProblems' />Thyroid Problems </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbVisionProblems' name='cbVisionProblems' className='add-only' value='VisionProblems' />Vision Problems </td>
                        <td className='w-250'><input type='checkbox' id='cbSleepProblems' name='cbSleepProblems' className='add-only' value='SleepProblems' />Sleep Problems </td>
                        <td className='w-250'><input type='checkbox' id='cbThyroidProblems' name='cbThyroidProblems' className='add-only' value='ThyroidProblems' />Thyroid Problems </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbKidneyProblems' name='cbKidneyProblems' className='add-only' value='KidneyProblems' />Kidney Problems </td>
                        <td className='w-250'><input type='checkbox' id='cbHearingProblems' name='cbHearingProblems' className='add-only' value='HearingProblems' />Hearing Problems </td>
                        <td className='w-250'><input type='checkbox' id='cbChronicPain' name='cbChronicPain' className='add-only' value='ChronicPain' />Chronic Pain </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbBloodDisorder' name='cbBloodDisorder' className='add-only' value='BloodDisorder' />Blood Disorder </td>
                        <td className='w-250'><input type='checkbox' id='cbLiverProblems' name='cbLiverProblems' className='add-only' value='LiverProblems' />Liver Problems </td>
                        <td className='w-250'><input type='checkbox' id='cbDentalProblems' name='cbDentalProblems' className='add-only' value='DentalProblems' />Dental Problems </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbPregnant' name='cbPregnant' className='add-only' value='Pregnant' />Pregnant </td>
                        <td className='w-250'><input type='checkbox' id='cbIntestinalProblems' name='cbIntestinalProblems' className='add-only' value='StomachIntestinalProblems' />Stomach/Intestinal Problems </td>
                        <td className='w-250'><input type='checkbox' id='cbLungProblems' name='cbLungProblems' className='add-only' value='AsthmaLungProblems' />Asthma/Lung Problems </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSexuallyTransmittedDisease' name='cbSexuallyTransmittedDisease' className='add-only' value='SexuallyTransmittedDisease' />Sexually Transmitted Disease(s):
                            <input type='text' id='txtSexuallyTransmittedDisease' name='txtSexuallyTransmittedDisease' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCancer' name='cbCancer' className='add-only' value='Cancer' />Cancer (specify type[s]):
                            <input type='text' id='txtCancer' name='txtCancer' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbInfection' name='cbInfection' className='add-only' value='Infection' />Infection(s):
                            <input type='text' id='txtInfection' name='txtInfection' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAllergies' name='cbAllergies' className='add-only' value='Allergies' />Allergies:
                            <input type='text' id='txtAllergies' name='txtAllergies' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbMedicalConditionOther' name='cbMedicalConditionOther' className='add-only' value='Other' />Other:
                            <input type='text' id='txtMedicalConditionOther' name='txtMedicalConditionOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>11. Do any of these conditions significantly interfere with your life?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbInterfereWithLifeYes' name='rbInterfereWithLife' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbInterfereWithLifeNo' name='rbInterfereWithLife' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe:
                            <input type='text' id='txtInterfereWithLifeDescribe' name='txtInterfereWithLifeDescribe' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>12. Provide additional comments on medical conditions, prior hospitalizations (include dates and reasons)</span></p>
                <p className='w-750'>
                    <textarea id='txtCommentsMedicalConditions' name='txtCommentsMedicalConditions' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>13. Question to be answered by interviewer: Does the patient report medical symptoms that would be considered life-threatening or require immediate medical attention?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbImmediateMedicalAttentionYes' name='rbImmediateMedicalAttention' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbImmediateMedicalAttentionNo' name='rbImmediateMedicalAttention' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>If yes, consider immediate referral to emergency room or call 911</b></p>
                <p className='w-750'><h2>14. List all current medication(s) for medical condition(s):</h2></p>

                <table>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(1) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDoseFrequency_1' name='txtDoseFrequency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtReason_1' name='txtReason_1' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtEffectiveness_1' name='txtEffectiveness_1' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(2) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDoseFrequency_2' name='txtDoseFrequency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtReason_2' name='txtReason_2' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtEffectiveness_2' name='txtEffectiveness_2' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(3) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDoseFrequency_3' name='txtDoseFrequency_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtReason_3' name='txtReason_3' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtEffectiveness_3' name='txtEffectiveness_3' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(4) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDoseFrequency_4' name='txtDoseFrequency_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtReason_4' name='txtReason_4' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtEffectiveness_4' name='txtEffectiveness_4' className='add-only' /></td>
                    </tr>


                </table>


                <p className='w-750'>Please circle one of the following levels of severity</p>
                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Severity Rating- Dimension 1 (Substance Use, Acute Intoxication and/or Withdrawal Potential)</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'> 0 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension2_0' name='rbSeverityRatingDimension2' className='add-only' value='None' /><b> None
                                <span className='small'>Fully functional/ able to cope with discomfort or pain.</span></b>
                        </td>
                        <td className='w-150'> 1 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension2_1' name='rbSeverityRatingDimension2' className='add-only' value='Mild' /><b> Mild
                                <span className='small'>Mild to moderate symptoms interfering with daily functioning. Adequate ability to cope with physical discomfort.</span></b>
                        </td>
                        <td className='w-150'> 2 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension2_2' name='rbSeverityRatingDimension2' className='add-only' value='Moderate' /><b> Moderate
                                <span className='small'>Some difficulty tolerating physical problems. Acute, nonlife threatening problems present, or serious biomedical problems are neglected.</span></b>
                        </td>
                        <td className='w-150'> 3 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension2_3' name='rbSeverityRatingDimension2' className='add-only' value='Severe' /><b> Severe
                                <span className='small'>Serious medical problems neglected during outpatient or intensive outpatient treatment. Severe medical problems present but stable. Poor ability to cope with physical problems.</span></b>
                        </td>
                        <td className='w-150'> 4 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension2_4' name='rbSeverityRatingDimension2' className='add-only' value='VerySevere' /><b> Very Severe
                                <span className='small'>Incapacitated with severe medical problems.</span></b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Additional Comment</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSeverityRatingDimension2AdditionalInformation' name='txtSeverityRatingDimension2AdditionalInformation' className='add-only' /></td>
                    </tr>

                </table>


                <p className='w-750'><h2>Dimension 3: Emotional, Behavioral, or Cognitive Conditions and Complications</h2></p>
                <p className='w-750'><h3>15. Do you consider any of the following behaviors or symptoms to be problematic?</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mood</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDepression' name='cbDepression' className='add-only' value='DepressionSadness' /> Depression/sadness</td>
                        <td className='w-250'><input type='checkbox' id='cbLossPleasure' name='cbLossPleasure' className='add-only' value='LossPleasureInterest' /> Loss of Pleasure/Interest</td>
                        <td className='w-250'><input type='checkbox' id='cbHopelessness' name='cbHopelessness' className='add-only' value='Hopelessness' /> Hopelessness</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbIrritability' name='cbIrritability' className='add-only' value='IrritabilityAnger' /> Irritability/Anger</td>
                        <td className='w-250'><input type='checkbox' id='cbImpulsivity' name='cbImpulsivity' className='add-only' value='Impulsivity' />  Impulsivity</td>
                        <td className='w-250'><input type='checkbox' id='cbPressuredSpeech' name='cbPressuredSpeech' className='add-only' value='PressuredSpeech' /> Pressured Speech</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbGrandiosity' name='cbGrandiosity' className='add-only' value='Grandiosity' /> Grandiosity</td>
                        <td className='w-250'><input type='checkbox' id='cbRacingThoughts' name='cbRacingThoughts' className='add-only' value='RacingThoughts' /> Racing Thoughts</td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Anxiety</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbExcessiveWorry' name='cbExcessiveWorry' className='add-only' value='AnxietyExcessiveWorry' /> Anxiety/Excessive Worry</td>
                        <td className='w-250'><input type='checkbox' id='cbObsessiveThoughts' name='cbObsessiveThoughts' className='add-only' value='ObsessiveThoughts' /> Obsessive Thoughts</td>
                        <td className='w-250'><input type='checkbox' id='cbCompulsiveBehaviors' name='cbCompulsiveBehaviors' className='add-only' value='CompulsiveBehaviors' /> Compulsive Behaviors</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFlashbacks' name='cbFlashbacks' className='add-only' value='Flashbacks' /> Flashbacks</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Psychosis</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbParanoia' name='cbParanoia' className='add-only' value='Paranoia' /> Paranoia</td>
                        <td className='w-250'><input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='Delusions' /> Delusions</td>
                        <td className='w-250'><input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbExcessiveWorry' name='cbExcessiveWorry' className='add-only' value='SleepProblems' /> Sleep Problems</td>
                        <td className='w-250'><input type='checkbox' id='cbObsessiveThoughts' name='cbObsessiveThoughts' className='add-only' value='MemoryConcentration' /> Memory/Concentration</td>
                        <td className='w-250'><input type='checkbox' id='cbCompulsiveBehaviors' name='cbCompulsiveBehaviors' className='add-only' value='GamblingRisky' /> Gambling Risky</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFlashbacks' name='cbFlashbacks' className='add-only' value='SexBehaviors' /> Sex Behaviors</td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSuicidalThoughtsDescribe' name='cbSuicidalThoughtsDescribe' className='add-only' value='SuicidalThoughts' /> Suicidal Thoughts: please describe :
                            <input type='text' id='txtSuicidalThoughtsDescribe' name='txtSuicidalThoughtsDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbHarmingOthers' name='cbHarmingOthers' className='add-only' value='ThoughtsHarming' /> Thoughts of Harming Others: please describe :
                            <input type='text' id='txtHarmingOthers' name='txtHarmingOthers' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbAbusePhysicalDescribe' name='cbAbusePhysicalDescribe' className='add-only' value='Abuse' /> Abuse (physical, emotional, sexual): please describe :
                            <input type='text' id='txtAbusePhysicalDescribe' name='txtAbusePhysicalDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTraumaticEventDescribe' name='cbTraumaticEventDescribe' className='add-only' value='TraumaticEvent' /> Traumatic Event(s): please describe :
                            <input type='text' id='txtTraumaticEventDescribe' name='txtTraumaticEventDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOtherDimension3Describe' name='cbOtherDimension3Describe' className='add-only' value='Other' /> Other :
                            <input type='text' id='txtOtherDimension3Describe' name='txtOtherDimension3Describe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>16. Have you ever been diagnosed with a mental illness?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMentalIllnessYes' name='rbMentalIllness' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbMentalIllnessNo' name='rbMentalIllness' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbMentalIllnessNotSure' name='rbMentalIllness' className='add-only' value='NotSure' /> Not Sure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe (e.g., diagnosis, medications?) :
                            <input type='text' id='txtMentalIllnessDescribe' name='txtMentalIllnessDescribe' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>17. Are you currently or have you previously received treatment for psychiatric or emotional problems?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbEmotionalProblemsYes' name='rbEmotionalProblems' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEmotionalProblemsNo' name='rbEmotionalProblems' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe (e.g., treatment setting, hospitalizations, duration of treatment) :
                            <input type='text' id='txtEmotionalProblemsDescribe' name='txtEmotionalProblemsDescribe' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>18. Do you ever see or hear things that other people say they do not see or hear?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHearThingsYes' name='rbHearThings' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHearThingsNo' name='rbHearThings' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe :
                            <input type='text' id='txtHearThingsDescribe' name='txtHearThingsDescribe' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>19. Question to be answered by interviewer: Based on previous questions, is further assessment of mental healthneeded?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbHealthneededYes' name='rbHealthneeded' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbHealthneededNo' name='rbHealthneeded' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe :
                            <input type='text' id='txtHealthneededDescribe' name='txtHealthneededDescribe' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h2>20. List all current medication(s) for psychiatric condition(s)</h2></p>

                <table>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(1) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionMedication_1' name='txtPsychiatricConditionMedication_1' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionDoseFrequency_1' name='txtPsychiatricConditionDoseFrequency_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionReason_1' name='txtPsychiatricConditionReason_1' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionEffectiveness_1' name='txtPsychiatricConditionEffectiveness_1' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(2) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionMedication_2' name='txtPsychiatricConditionMedication_2' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionDoseFrequency_2' name='txtPsychiatricConditionDoseFrequency_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionReason_2' name='txtPsychiatricConditionReason_2' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionEffectiveness_2' name='txtPsychiatricConditionEffectiveness_2' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(3) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionMedication_3' name='txtPsychiatricConditionMedication_3' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionDoseFrequency_3' name='txtPsychiatricConditionDoseFrequency_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionReason_3' name='txtPsychiatricConditionReason_3' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionEffectiveness_3' name='txtPsychiatricConditionEffectiveness_3' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'><span className='eleHeader'>(4) Medication</span></td>
                        <td className='w-375'><span className='eleHeader'>Dose/Frequency</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionMedication_4' name='txtPsychiatricConditionMedication_4' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionDoseFrequency_4' name='txtPsychiatricConditionDoseFrequency_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Reason </span></td>
                        <td className='w-375'><span className='eleHeader'>Effectiveness/Side Effects</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionReason_4' name='txtPsychiatricConditionReason_4' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtPsychiatricConditionEffectiveness_4' name='txtPsychiatricConditionEffectiveness_4' className='add-only' /></td>
                    </tr>


                </table>
                <p className='w-750'><h2>21. Please list mental health provider(s)</h2></p>

                <table>

                    <tr>
                        <td className='w-375'><span className='eleHeader'>ProviderName</span></td>
                        <td className='w-375'><span className='eleHeader'> ContactInformation</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtContactInformation_1' name='txtContactInformation_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtContactInformation_2' name='txtContactInformation_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtContactInformation_3' name='txtContactInformation_3' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='text' id='txtProviderName_4' name='txtProviderName_4' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtContactInformation_4' name='txtContactInformation_4' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'>Please circle one of the following levels of severity</p>
                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Severity Rating- Dimension 3 (Emotional, Behavioral, or Cognitive Conditions and Complications)</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'> 0 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension3_0' name='rbSeverityRatingDimension3' className='add-only' value='None' /><b> None
                                <span className='small'>Good impulse control and coping skills. No dangerousness, good social functioning and self-care, no interference with recovery.</span></b>
                        </td>
                        <td className='w-150'> 1 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension3_1' name='rbSeverityRatingDimension3' className='add-only' value='Mild' /><b> Mild
                                <span className='small'>Suspect diagnosis of EBC, requires intervention, but does not interfere with recovery. Some relationship impairment.</span></b>
                        </td>
                        <td className='w-150'> 2 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension3_2' name='rbSeverityRatingDimension3' className='add-only' value='Moderate' /><b> Moderate
                                <span className='small'>Persistent EBC. Symptoms distract from recovery, but no immediate threat to self/others. Does not prevent independent functioning.</span></b>
                        </td>
                        <td className='w-150'> 3 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension3_3' name='rbSeverityRatingDimension3' className='add-only' value='Severe' /><b> Severe
                                <span className='small'>Severe EBC, but does not require acute level of care. Impulse to harm self or others, but not dangerous in a 24-hr setting.</span></b>
                        </td>
                        <td className='w-150'> 4 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension3_4' name='rbSeverityRatingDimension3' className='add-only' value='VerySevere' /><b> Very Severe
                                <span className='small'>Severe EBC. Requires acute level of care. Exhibits severe and acute lifethreatening symptoms (posing imminent danger to self/others).</span></b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Additional Comment</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSeverityRatingDimension3AdditionalInformation' name='txtSeverityRatingDimension3AdditionalInformation' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><h2>Dimension 4: Readiness to Change</h2></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>22. Is your alcohol and/or drug use affecting any of the following?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbWork' name='cbWork' className='add-only' value='Work' /> Work</td>
                        <td className='w-250'><input type='checkbox' id='cbMentalHealth' name='cbMentalHealth' className='add-only' value='MentalHealth' /> Mental Health</td>
                        <td className='w-250'><input type='checkbox' id='cbPhysicalHealth' name='cbPhysicalHealth' className='add-only' value='PhysicalHealth' /> Physical Health</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbFinances' name='cbFinances' className='add-only' value='Finances' /> Finances</td>
                        <td className='w-250'><input type='checkbox' id='cbSchool' name='cbSchool' className='add-only' value='School' /> School</td>
                        <td className='w-250'><input type='checkbox' id='cbRelationships' name='cbRelationships' className='add-only' value='Relationships' /> Relationships</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSexualActivity' name='cbSexualActivity' className='add-only' value='SexualActivity' /> Sexual Activity </td>
                        <td className='w-250'><input type='checkbox' id='cbLegalMatters' name='cbLegalMatters' className='add-only' value='LegalMatters' /> Legal Matters</td>
                        <td className='w-250'><input type='checkbox' id='cbHandlingEverydayTasks' name='cbHandlingEverydayTasks' className='add-only' value='HandlingEverydayTasks' /> Handling Everyday Tasks</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSelfesteem' name='cbSelfesteem' className='add-only' value='Selfesteem' /> Self-esteem</td>
                        <td className='w-250'><input type='checkbox' id='cbHygiene' name='cbHygiene' className='add-only' value='Hygiene' /> Hygiene</td>
                        <td className='w-250'><input type='checkbox' id='cbRecreationalActivities' name='cbRecreationalActivities' className='add-only' value='RecreationalActivities' /> Recreational Activities</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Other : <input type='text' id='txtSelfsteem' name='txtSelfsteem' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>23. Do you continue to use alcohol or drugs despite having it affect the areas listed above?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbContinueUseYes' name='rbContinueUse' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbContinueUseNo' name='rbContinueUse' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Please describe :
                            <input type='text' id='txtContinueUseDescribe' name='txtContinueUseDescribe' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>24. Have you received help for alcohol and/or drug problems in the past?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbDrugProblemsInPastYes' name='rbDrugProblemsInPast' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbDrugProblemsInPastNo' name='rbDrugProblemsInPast' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='small'>Please list treatment provider(s)</span></td>
                    </tr>
                </table>


                <table>

                    <tr>
                        <td className='w-375'><span className='eleHeader'> ProviderName</span></td>
                        <td className='w-375'><span className='eleHeader'> ContactInformation</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastProviderName_1' name='txtDrugProblemsInPastProviderName_1' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastContactInformation_1' name='txtDrugProblemsInPastContactInformation_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastProviderName_2' name='txtDrugProblemsInPastProviderName_2' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastContactInformation_2' name='txtDrugProblemsInPastContactInformation_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastProviderName_3' name='txtDrugProblemsInPastProviderName_3' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastContactInformation_3' name='txtDrugProblemsInPastContactInformation_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastProviderName_4' name='txtDrugProblemsInPastProviderName_4' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtDrugProblemsInPastContactInformation_4' name='txtDrugProblemsInPastContactInformation_4' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><span className='eleHeader'>25. What would help to support your recovery?</span></p>
                <p className='w-750'>
                    <textarea id='txtHelpSupportRecovery' name='txtHelpSupportRecovery' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>26. What are potential barriers to your recovery (e.g., financial, transportation, relationships, etc.)?</span></p>
                <p className='w-750'>
                    <textarea id='txtPotentialBarriersToRecovery' name='txtPotentialBarriersToRecovery' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>27. How important is it for you to receive treatment for</h2></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Alcohal Problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='radio' id='rbAlcoholProblemsNotAtAll' name='rbAlcoholProblems' className='add-only' value='NotAtAll' /> Not at all</td>
                        <td className='w-150'><input type='radio' id='rbAlcoholProblemsSlightly' name='rbAlcoholProblems' className='add-only' value='Slightly' /> Slightly</td>
                        <td className='w-150'><input type='radio' id='rbAlcoholProblemsModerately' name='rbAlcoholProblems' className='add-only' value='Moderately' /> Moderately</td>
                        <td className='w-150'><input type='radio' id='rbAlcoholProblemsConsiderably' name='rbAlcoholProblems' className='add-only' value='Considerably' /> Considerably</td>
                        <td className='w-150'><input type='radio' id='rbAlcoholProblemsExtremely' name='rbAlcoholProblems' className='add-only' value='Extremely' /> Extremely</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Drug Problems</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='radio' id='rbDrugProblemsNotAtAll' name='rbDrugProblems' className='add-only' value='NotAtAll' /> Not at all</td>
                        <td className='w-150'><input type='radio' id='rbDrugProblemsSlightly' name='rbDrugProblems' className='add-only' value='Slightly' /> Slightly</td>
                        <td className='w-150'><input type='radio' id='rbDrugProblemsModerately' name='rbDrugProblems' className='add-only' value='Moderately' /> Moderately</td>
                        <td className='w-150'><input type='radio' id='rbDrugProblemsConsiderably' name='rbDrugProblems' className='add-only' value='Considerably' /> Considerably</td>
                        <td className='w-150'><input type='radio' id='rbDrugProblemsExtremely' name='rbDrugProblems' className='add-only' value='Extremely' /> Extremely</td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtDrugProblemsDescribe' name='txtDrugProblemsDescribe' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>Please circle one of the following levels of severity</p>
                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Severity Rating- Dimension 4 (Readiness to Change)</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'> 0 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension4_0' name='rbSeverityRatingDimension4' className='add-only' value='None' /><b> None
                                <span className='small'>Willing to engage in treatment.</span></b>
                        </td>
                        <td className='w-150'> 1 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension4_1' name='rbSeverityRatingDimension4' className='add-only' value='Mild' /><b> Mild
                                <span className='small'>Willing to enter treatment, but ambivalent to the need to change.</span></b>
                        </td>
                        <td className='w-150'> 2 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension4_2' name='rbSeverityRatingDimension4' className='add-only' value='Moderate' /><b> Moderate
                                <span className='small'>Reluctant to agree to treatment. Low commitment to change substance use. Passive engagement in treatment.</span></b>
                        </td>
                        <td className='w-150'> 3 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension4_3' name='rbSeverityRatingDimension4' className='add-only' value='Severe' /><b> Severe
                                <span className='small'>Unaware of need to change. Unwilling or partially able to follow through with recommendations for treatment.</span></b>
                        </td>
                        <td className='w-150'> 4 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension4_4' name='rbSeverityRatingDimension4' className='add-only' value='VerySevere' /><b> Very Severe
                                <span className='small'>Not willing to change. Unwilling/unable to follow through with treatment recommendations.</span></b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Additional Comment</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSeverityRatingDimension4AdditionalInformation' name='txtSeverityRatingDimension4AdditionalInformation' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><h2>Dimension 5: Relapse, Continued Use, or Continued Problem Potential</h2></p>
                <p className='w-750'><h3>28. In the last 30 days, how often have you experienced cravings, withdrawal symptoms, disturbing effects of use?</h3></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Alcohal</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbSymptomsAlcohalNone' name='rbSymptomsAlcohal' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='radio' id='rbSymptomsAlcohalOccasionally' name='rbSymptomsAlcohal' className='add-only' value='Occasionally' /> Occasionally</td>
                        <td className='w-187'><input type='radio' id='rbSymptomsAlcohalFrequently' name='rbSymptomsAlcohal' className='add-only' value='Frequently' /> Frequently</td>
                        <td className='w-187'><input type='radio' id='rbSymptomsAlcohalConstantly' name='rbSymptomsAlcohal' className='add-only' value='Constantly' /> Constantly</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Drug</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='radio' id='rbSymptomsDrugNone' name='rbSymptomsDrug' className='add-only' value='None' /> None</td>
                        <td className='w-187'><input type='radio' id='rbSymptomsDrugOccasionally' name='rbSymptomsDrug' className='add-only' value='Occasionally' /> Occasionally</td>
                        <td className='w-187'><input type='radio' id='rbSymptomsDrugFrequently' name='rbSymptomsDrug' className='add-only' value='Frequently' /> Frequently</td>
                        <td className='w-187'><input type='radio' id='rbSymptomsDrugConstantly' name='rbSymptomsDrug' className='add-only' value='Constantly' /> Constantly</td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtSymptomsDrug' name='txtSymptomsDrug' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>29. Do you find yourself spending time searching for alcohol and/or drugs, or trying to recover from its effects?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSearchingAlcoholYes' name='rbSearchingAlcohol' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSearchingAlcoholNo' name='rbSearchingAlcohol' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtSearchingAlcohol' name='txtSearchingAlcohol' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>30. Do you feel that you will either relapse or continue to use without treatment or additional support?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWithoutTreatmentYes' name='rbWithoutTreatment' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWithoutTreatmentNo' name='rbWithoutTreatment' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtWithoutTreatment' name='txtWithoutTreatment' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>31. Are you aware of your triggers to use alcohol and/or drugs?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTriggersToUseAlcoholYes' name='rbTriggersToUseAlcohol' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTriggersToUseAlcoholNo' name='rbTriggersToUseAlcohol' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='small'>Please check off any triggers that may apply:</span></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbStrongCravings' id='cbStrongCravings' className='add-only' value='StrongCravings' /> Strong Cravings</td>
                        <td className='w-250'><input type='checkbox' name='cbWorkPressure' id='cbWorkPressure' className='add-only' value='WorkPressure' /> Work Pressure</td>
                        <td className='w-250'><input type='checkbox' name='cbMentalHealth' id='cbMentalHealth' className='add-only' value='MentalHealth' /> Mental Health</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbRelationshipProblems' id='cbRelationshipProblems' className='add-only' value='RelationshipProblems' /> Relationship Problems</td>
                        <td className='w-250'><input type='checkbox' name='cbDifficultyDealingFeelings' id='cbDifficultyDealingFeelings' className='add-only' value='DifficultyDealingFeelings' /> Difficulty Dealing with Feelings</td>
                        <td className='w-250'><input type='checkbox' name='cbFinancialStressors' id='cbFinancialStressors' className='add-only' value='FinancialStressors' /> Financial Stressors</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbPhysicalHealth' id='cbPhysicalHealth' className='add-only' value='PhysicalHealth' /> Physical Health </td>
                        <td className='w-250'><input type='checkbox' name='cbSchoolPressure' id='cbSchoolPressure' className='add-only' value='SchoolPressure' /> School Pressure</td>
                        <td className='w-250'><input type='checkbox' name='cbEnvironment' id='cbEnvironment' className='add-only' value='Environment' /> Environment</td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='checkbox' name='cbUnemployment' id='cbUnemployment' className='add-only' value='Unemployment' /> Unemployment</td>
                        <td className='w-250'><input type='checkbox' name='cbChronicPain' id='cbChronicPain' className='add-only' value='ChronicPain' /> Chronic Pain</td>
                        <td className='w-250'><input type='checkbox' name='cbPeerPressure' id='cbPeerPressure' className='add-only' value='PeerPressure' /> Peer Pressure</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='cbTriggersAlcoholOther' id='cbTriggersAlcoholOther' className='add-only' value='TriggersAlcoholOther' /> Other :
                            <input type='text' id='txtTriggersAlcoholOther' name='TriggersAlcoholOther' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>32. What do you do if you are triggered?</span></p>
                <p className='w-750'>
                    <textarea id='txtIfTriggered' name='txtIfTriggered' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>33. Can you please describe any attempts you have made to either control or cut down on your alcohol and/or drug use?</span></p>
                <p className='w-750'>
                    <textarea id='txtAttemptsMade' name='txtAttemptsMade' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>34. What is the longest period of time that you have gone without using alcohol and/or drugs?</span></p>
                <p className='w-750'>
                    <textarea id='txtWithoutUsingAlcohol' name='txtWithoutUsingAlcohol' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>35. What helped and didn't help?</span></p>
                <p className='w-750'>
                    <textarea id='txtWhatHelpAndDidNotHelp' name='txtWhatHelpAndDidNotHelp' className='add-only'></textarea>
                </p>

                <p className='w-750'>Please circle one of the following levels of severity</p>
                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Severity Rating- Dimension 5 (Relapse, continued Use, or Continued Problem Potential)</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'> 0 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension5_0' name='rbSeverityRatingDimension5' className='add-only' value='None' /><b> None
                                <span className='small'>Low/no potential for relapse. Good ability to cope.</span></b>
                        </td>
                        <td className='w-150'> 1 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension5_1' name='rbSeverityRatingDimension5' className='add-only' value='Mild' /><b> Mild
                                <span className='small'>Minimal relapse potential. Some risk, but fair coping and relapse prevention skills.</span></b>
                        </td>
                        <td className='w-150'> 2 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension5_2' name='rbSeverityRatingDimension5' className='add-only' value='Moderate' /><b> Moderate
                                <span className='small'>Impaired recognition of risk for relapse. Able to self-manage with prompting.</span></b>
                        </td>
                        <td className='w-150'> 3 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension5_3' name='rbSeverityRatingDimension5' className='add-only' value='Severe' /><b> Severe
                                <span className='small'>Little recognition of risk for relapse, poor skills to cope with relapse.</span></b>
                        </td>
                        <td className='w-150'> 4 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension5_4' name='rbSeverityRatingDimension5' className='add-only' value='VerySevere' /><b> Very Severe
                                <span className='small'>No coping skills for relapse/ addiction problems. Substance use/behavior, places self/other in imminent danger.</span></b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Additional Comment</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSeverityRatingDimension5AdditionalInformation' name='txtSeverityRatingDimension5AdditionalInformation' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><h2>Dimension 6: Recovery/Living Environment</h2></p>

                <p className='w-750'><span className='eleHeader'>36. Do you have any relationships that are supportive of your recovery? (e.g., family, friends)</span></p>
                <p className='w-750'>
                    <textarea id='txtSupportiveOfRecovery' name='txtSupportiveOfRecovery' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>37. What is your current living situation (e.g., homeless, living with family/alone)?</span></p>
                <p className='w-750'>
                    <textarea id='txtLivingSituation' name='txtLivingSituation' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>38. Do you currently live in an environment where others are using drugs?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbEnvironmentUsingDrugsYes' name='rbEnvironmentUsingDrugs' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbEnvironmentUsingDrugsNo' name='rbEnvironmentUsingDrugs' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtEnvironmentUsingDrugs' name='txtEnvironmentUsingDrugs' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>39. Are you currently involved in relationships or situations that pose a threat to your safety?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbPoseThreatYes' name='rbPoseThreat' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbPoseThreatNo' name='rbPoseThreat' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtPoseThreat' name='txtPoseThreat' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>40. Are you currently involved in relationships or situations that would negatively impact your recovery?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbNegativelyImpactRecoveryYes' name='rbNegativelyImpactRecovery' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNegativelyImpactRecoveryNo' name='rbNegativelyImpactRecovery' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtNegativelyImpactRecovery' name='txtNegativelyImpactRecovery' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>41. Are you currently employed or enrolled in school?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbCurrentlyEmployedYes' name='rbCurrentlyEmployed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbCurrentlyEmployedNo' name='rbCurrentlyEmployed' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtCurrentlyEmployed' name='txtCurrentlyEmployed' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>42. Are you currently involved with social services or the legal system (e.g., DCFS, court mandated, probation, parole)?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbSocialServiceLegalSystemYes' name='rbSocialServiceLegalSystem' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbSocialServiceLegalSystemNo' name='rbSocialServiceLegalSystem' className='add-only' value='No' /> No
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>Please describe : <input type='text' id='txtSocialServiceLegalSystem' name='txtSocialServiceLegalSystem' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>If on parole/probation:</td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name of Probation/Parole Officer </span></td>
                        <td className='w-375'><span className='eleHeader'>Contact Information </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtNameProbation' name='txtNameProbation' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtContactInformation' name='txtContactInformation' className='add-only' /></td>
                    </tr>
                </table>






                <p className='w-750'>Please circle one of the following levels of severity</p>
                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Severity Rating- Dimension 6 Recovery/Living Environment</span></td>
                    </tr>

                    <tr>
                        <td className='w-150'> 0 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension6_0' name='rbSeverityRatingDimension6' className='add-only' value='None' /><b> None
                                <span className='small'>Able to cope in environment/supportive.</span></b>
                        </td>
                        <td className='w-150'> 1 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension6_1' name='rbSeverityRatingDimension6' className='add-only' value='Mild' /><b> Mild
                                <span className='small'>Passive/disinterested social support, but still able to cope.</span></b>
                        </td>
                        <td className='w-150'> 2 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension6_2' name='rbSeverityRatingDimension6' className='add-only' value='Moderate' /><b> Moderate
                                <span className='small'>Unsupportive environment, but able to cope with clinical structure most of the time.</span></b>
                        </td>
                        <td className='w-150'> 3 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension6_3' name='rbSeverityRatingDimension6' className='add-only' value='Severe' /><b> Severe
                                <span className='small'>Unsupportive environment, difficulty coping even with clinical structure.</span></b>
                        </td>
                        <td className='w-150'> 4 &nbsp;
                            <input type='radio' id='rbSeverityRatingDimension6_4' name='rbSeverityRatingDimension6' className='add-only' value='VerySevere' /><b> Very Severe
                                <span className='small'>Environment toxic/hostile to recovery. Unable to cope and the environment may pose a threat to safety.</span></b>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Additional Comment</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSeverityRatingDimension6AdditionalInformation' name='txtSeverityRatingDimension6AdditionalInformation' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><h3>Summary of Multidimensional Assessment</h3></p>
                <ul>
                    <li><b>Dimension 1:</b> Substance Use, Acute Intoxication and/or Withdrawal Potential</li>
                    <li><b>Dimension 2:</b> Biomedical Condition and Complications</li>
                    <li><b>Dimension 3:</b> Emotional, Behavioral, or Cognitive Condition and Complications</li>
                    <li><b>Dimension 4:</b> Readiness to Change</li>
                    <li><b>Dimension 5:</b> Relapse, Continued Use, or Continued Problem Potential</li>
                    <li><b>Dimension 6:</b> Recovery/Living Environment</li>
                </ul>

                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Dimension</span></td>
                        <td className='w-350'><span className='eleHeader'>Severity Rating (Based on Ratings Above) </span></td>
                        <td className='w-250'><span className='eleHeader'>Rationale</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'><b>Dimension 1:</b></td>
                        <td className='w-350'>
                            <input type='radio' id='rbMultidimensionalAssessmentNone_1' name='rbMultidimensionalAssessment_1' className='add-only' value='None' /> 0 None &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentMild_1' name='rbMultidimensionalAssessment_1' className='add-only' value='Mild' /> 1 Mild &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentModerate_1' name='rbMultidimensionalAssessment_1' className='add-only' value='Moderate' /> 2 Moderate &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentSevere_1' name='rbMultidimensionalAssessment_1' className='add-only' value='Severe' /> 3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMultidimensionalAssessmentRationale_1' name='txtMultidimensionalAssessmentRationale_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><b>Dimension 2:</b></td>
                        <td className='w-350'>
                            <input type='radio' id='rbMultidimensionalAssessmentNone_2' name='rbMultidimensionalAssessment_2' className='add-only' value='None' /> 0 None &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentMild_2' name='rbMultidimensionalAssessment_2' className='add-only' value='Mild' /> 1 Mild &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentModerate_2' name='rbMultidimensionalAssessment_2' className='add-only' value='Moderate' /> 2 Moderate &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentSevere_2' name='rbMultidimensionalAssessment_2' className='add-only' value='Severe' /> 3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMultidimensionalAssessmentRationale_2' name='txtMultidimensionalAssessmentRationale_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><b>Dimension 3:</b></td>
                        <td className='w-350'>
                            <input type='radio' id='rbMultidimensionalAssessmentNone_3' name='rbMultidimensionalAssessment_3' className='add-only' value='None' /> 0 None &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentMild_3' name='rbMultidimensionalAssessment_3' className='add-only' value='Mild' /> 1 Mild &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentModerate_3' name='rbMultidimensionalAssessment_3' className='add-only' value='Moderate' /> 2 Moderate &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentSevere_3' name='rbMultidimensionalAssessment_3' className='add-only' value='Severe' /> 3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMultidimensionalAssessmentRationale_3' name='txtMultidimensionalAssessmentRationale_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><b>Dimension 4:</b></td>
                        <td className='w-350'>
                            <input type='radio' id='rbMultidimensionalAssessmentNone_4' name='rbMultidimensionalAssessment_4' className='add-only' value='None' /> 0 None &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentMild_4' name='rbMultidimensionalAssessment_4' className='add-only' value='Mild' /> 1 Mild &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentModerate_4' name='rbMultidimensionalAssessment_4' className='add-only' value='Moderate' /> 2 Moderate &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentSevere_4' name='rbMultidimensionalAssessment_4' className='add-only' value='Severe' /> 3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMultidimensionalAssessmentRationale_4' name='txtMultidimensionalAssessmentRationale_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><b>Dimension 5:</b></td>
                        <td className='w-350'>
                            <input type='radio' id='rbMultidimensionalAssessmentNone_5' name='rbMultidimensionalAssessment_5' className='add-only' value='None' /> 0 None &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentMild_5' name='rbMultidimensionalAssessment_5' className='add-only' value='Mild' /> 1 Mild &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentModerate_5' name='rbMultidimensionalAssessment_5' className='add-only' value='Moderate' /> 2 Moderate &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentSevere_5' name='rbMultidimensionalAssessment_5' className='add-only' value='Severe' /> 3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMultidimensionalAssessmentRationale_5' name='txtMultidimensionalAssessmentRationale_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'><b>Dimension 6:</b></td>
                        <td className='w-350'>
                            <input type='radio' id='rbMultidimensionalAssessmentNone_6' name='rbMultidimensionalAssessment_6' className='add-only' value='None' /> 0 None &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentMild_6' name='rbMultidimensionalAssessment_6' className='add-only' value='Mild' /> 1 Mild &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentModerate_6' name='rbMultidimensionalAssessment_6' className='add-only' value='Moderate' /> 2 Moderate &nbsp;
                            <input type='radio' id='rbMultidimensionalAssessmentSevere_6' name='rbMultidimensionalAssessment_6' className='add-only' value='Severe' /> 3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMultidimensionalAssessmentRationale_6' name='txtMultidimensionalAssessmentRationale_6' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Diagnosis: Diagnostic Statistical Manual, 5th Edition (DSM-5) Criteria For Substance Use Disorder</h3></p>
                <p className='w-750'>Please check off any symptoms that have occurred in the past 12 months.</p>

                
                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Substance Use Disorder Criteria (DSM-5) </span></td>
                        <td className='w-300'><span className='eleHeader'>Name of Substance(s) </span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>&nbsp;</td>
                        <td className='w-100'>#1:</td>
                        <td className='w-100'>#2:</td>
                        <td className='w-100'>#3:</td>
                    </tr>
                    <tr>
                        <td className='w-450'>&nbsp;</td>
                        <td className='w-100'><input type='text' id='txt' name='txt' className='add-only w-100 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txt' name='txt' className='add-only w-100 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txt' name='txt' className='add-only w-100 custom-add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-450'>1. Substance often taken in larger amounts or over a longer period than was intended.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_1Substance_1' name='cbDisorderCriteria_1Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_1Substance_2' name='cbDisorderCriteria_1Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_1Substance_3' name='cbDisorderCriteria_1Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>2. There is a persistent desire or unsuccessful efforts to cut down or control substance use.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_2Substance_1' name='cbDisorderCriteria_2Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_2Substance_2' name='cbDisorderCriteria_2Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_2Substance_3' name='cbDisorderCriteria_2Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>3. A great deal of time is spent in activities necessary to obtain the substance, use the substance, or recover from its effects.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_3Substance_1' name='cbDisorderCriteria_3Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_3Substance_2' name='cbDisorderCriteria_3Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_3Substance_3' name='cbDisorderCriteria_3Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>4. Craving, or a strong desire or urge to use the substance.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_4Substance_1' name='cbDisorderCriteria_4Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_4Substance_2' name='cbDisorderCriteria_4Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_4Substance_3' name='cbDisorderCriteria_4Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>5. Recurrent substance use resulting in a failure to fulfill major role obligations at work, school, or home.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_5Substance_1' name='cbDisorderCriteria_5Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_5Substance_2' name='cbDisorderCriteria_5Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_5Substance_3' name='cbDisorderCriteria_5Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>6. Continued substance use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of thesubstance.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_6Substance_1' name='cbDisorderCriteria_6Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_6Substance_2' name='cbDisorderCriteria_6Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_6Substance_3' name='cbDisorderCriteria_6Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>7. Important social, occupational, or recreational activities are given up or reduced because of substance use.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_7Substance_1' name='cbDisorderCriteria_7Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_7Substance_2' name='cbDisorderCriteria_7Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_7Substance_3' name='cbDisorderCriteria_7Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>8. Recurrent substance use in situations in which it is physically hazardous</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_8Substance_1' name='cbDisorderCriteria_8Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_8Substance_2' name='cbDisorderCriteria_8Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_8Substance_3' name='cbDisorderCriteria_8Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>9. Continued substance use despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by the substance.</td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_9Substance_1' name='cbDisorderCriteria_9Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_9Substance_2' name='cbDisorderCriteria_9Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_9Substance_3' name='cbDisorderCriteria_9Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>10. Tolerance, as defined by either of the following:
                            -A need for markedly increased amounts of the substance toachieve intoxication or desired effect.
                            -A markedly diminished effect with continued use of the sameamount of the substance.
                        </td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_10Substance_1' name='cbDisorderCriteria_10Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_10Substance_2' name='cbDisorderCriteria_10Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_10Substance_3' name='cbDisorderCriteria_10Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>


                    <tr>
                        <td className='w-450'>11. Withdrawal, as manifested by either of the following:
                            -The characteristic withdrawal syndrome for the substance.
                            -Substance (or a closely related substance) is taken to relieve oravoid withdrawal symptoms.
                        </td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_11Substance_1' name='cbDisorderCriteria_11Substance_1' className='add-only' value='Substance_1' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_11Substance_2' name='cbDisorderCriteria_11Substance_2' className='add-only' value='Substance_2' /></center></td>
                        <td className='w-100'><center><input type='checkbox' id='cbDisorderCriteria_11Substance_3' name='cbDisorderCriteria_11Substance_3' className='add-only' value='Substance_3' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b>Total Number of Criteria :</b> <input type='text' id='txtDisorderCriteriaTotal' name='txtDisorderCriteriaTotal' className='add-only w-150 custom-add-only' />
                    </td>
                    </tr>
                    


                </table>

            


                <p className='w-750'><span className='eleHeader'>List of Substance Use Disorder(s) that Meet DSM-5 Criteria and Date of DSM-5 Diagnosis (specify severity level):</span></p>
                <p className='w-750'>
                    <textarea id='txtSubstanceUseDisorder' name='txtSubstanceUseDisorder' className='add-only'></textarea>
                </p>

                <p className='w-750'>*The presence of at least 2 of these criteria indicates a substance use disorder.</p>
                <p className='w-750'>** The severity of the substance use disorder is defined as:</p>

                <ul>
                    <li><b>Mild:</b> Presence of 2-3 criteria</li>
                    <li><b>Moderate:</b> Presence of 4-5 criteria</li>
                    <li><b>Severe:</b> Presence of 6 or more criteria</li>
                </ul>

                <p className='w-750'><h3><b>ASAM Level Of Care Determination Tool</b></h3></p>
                <p className='w-750'>Instructions: For each dimension, indicate the least intensive level of care that is appropriate based on the patient's severity/functioning and service needs.</p>

                <p className='w-750'><h4><b>Legend</b></h4></p>

                <ul>
                    <li><b>Dimension 1:</b> Substance Use, Acute Intoxication and/or Withdrawal Potential</li>
                    <li><b>Dimension 2:</b> Biomedical Condition and Complications</li>
                    <li><b>Dimension 3:</b> Emotional, Behavioral, or Cognitive Condition and Complications</li>
                    <li><b>Dimension 4:</b> Readiness to Change</li>
                    <li><b>Dimension 5:</b> Relapse, Continued Use, or Continued Problem Potential</li>
                    <li><b>Dimension 6:</b> Recovery/Living Environment</li>
                </ul>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care-Withdrawal Management</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Ambulatory Withdrawal Management without Extended On-Site Monitoring</b></td>
                        <td className='w-150'><b>1-WM</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_1Dimension_1None' name='rbCriteria_1Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_1Mild' name='rbCriteria_1Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_1Mod' name='rbCriteria_1Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_1Sev' name='rbCriteria_1Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_1Dimension_2None' name='rbCriteria_1Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_2Mild' name='rbCriteria_1Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_2Mod' name='rbCriteria_1Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_2Sev' name='rbCriteria_1Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_1Dimension_3None' name='rbCriteria_1Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_3Mild' name='rbCriteria_1Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_3Mod' name='rbCriteria_1Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_3Sev' name='rbCriteria_1Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_1Dimension_4None' name='rbCriteria_1Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_4Mild' name='rbCriteria_1Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_4Mod' name='rbCriteria_1Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_4Sev' name='rbCriteria_1Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_1Dimension_5None' name='rbCriteria_1Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_5Mild' name='rbCriteria_1Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_5Mod' name='rbCriteria_1Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_5Sev' name='rbCriteria_1Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_1Dimension_6None' name='rbCriteria_1Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_6Mild' name='rbCriteria_1Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_6Mod' name='rbCriteria_1Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_1Dimension_6Sev' name='rbCriteria_1Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care-Withdrawal Management</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Ambulatory Withdrawal Management with Extended On-Site Monitoring</b></td>
                        <td className='w-150'><b>2-WM</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_2Dimension_1None' name='rbCriteria_2Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_1Mild' name='rbCriteria_2Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_1Mod' name='rbCriteria_2Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_1Sev' name='rbCriteria_2Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_2Dimension_2None' name='rbCriteria_2Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_2Mild' name='rbCriteria_2Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_2Mod' name='rbCriteria_2Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_2Sev' name='rbCriteria_2Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_2Dimension_3None' name='rbCriteria_2Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_3Mild' name='rbCriteria_2Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_3Mod' name='rbCriteria_2Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_3Sev' name='rbCriteria_2Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_2Dimension_4None' name='rbCriteria_2Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_4Mild' name='rbCriteria_2Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_4Mod' name='rbCriteria_2Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_4Sev' name='rbCriteria_2Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_2Dimension_5None' name='rbCriteria_2Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_5Mild' name='rbCriteria_2Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_5Mod' name='rbCriteria_2Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_5Sev' name='rbCriteria_2Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_2Dimension_6None' name='rbCriteria_2Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_6Mild' name='rbCriteria_2Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_6Mod' name='rbCriteria_2Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_2Dimension_6Sev' name='rbCriteria_2Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care-Withdrawal Management</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Clinically Managed Residential Withdrawal Management</b></td>
                        <td className='w-150'><b>3.2-WM</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_32Dimension_1None' name='rbCriteria_32Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_1Mild' name='rbCriteria_32Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_1Mod' name='rbCriteria_32Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_1Sev' name='rbCriteria_32Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_32Dimension_2None' name='rbCriteria_32Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_2Mild' name='rbCriteria_32Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_2Mod' name='rbCriteria_32Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_2Sev' name='rbCriteria_32Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_32Dimension_3None' name='rbCriteria_32Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_3Mild' name='rbCriteria_32Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_3Mod' name='rbCriteria_32Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_3Sev' name='rbCriteria_32Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_32Dimension_4None' name='rbCriteria_32Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_4Mild' name='rbCriteria_32Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_4Mod' name='rbCriteria_32Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_4Sev' name='rbCriteria_32Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_32Dimension_5None' name='rbCriteria_32Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_5Mild' name='rbCriteria_32Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_5Mod' name='rbCriteria_32Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_5Sev' name='rbCriteria_32Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_32Dimension_6None' name='rbCriteria_32Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_6Mild' name='rbCriteria_32Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_6Mod' name='rbCriteria_32Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_32Dimension_6Sev' name='rbCriteria_32Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care-Withdrawal Management</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Medically Monitored Inpatient Withdrawal Management</b></td>
                        <td className='w-150'><b>3.7-WM</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_37Dimension_1None' name='rbCriteria_37Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_1Mild' name='rbCriteria_37Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_1Mod' name='rbCriteria_37Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_1Sev' name='rbCriteria_37Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_37Dimension_2None' name='rbCriteria_37Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_2Mild' name='rbCriteria_37Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_2Mod' name='rbCriteria_37Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_2Sev' name='rbCriteria_37Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_37Dimension_3None' name='rbCriteria_37Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_3Mild' name='rbCriteria_37Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_3Mod' name='rbCriteria_37Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_3Sev' name='rbCriteria_37Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_37Dimension_4None' name='rbCriteria_37Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_4Mild' name='rbCriteria_37Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_4Mod' name='rbCriteria_37Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_4Sev' name='rbCriteria_37Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_37Dimension_5None' name='rbCriteria_37Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_5Mild' name='rbCriteria_37Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_5Mod' name='rbCriteria_37Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_5Sev' name='rbCriteria_37Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_37Dimension_6None' name='rbCriteria_37Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_6Mild' name='rbCriteria_37Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_6Mod' name='rbCriteria_37Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_37Dimension_6Sev' name='rbCriteria_37Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care-Withdrawal Management</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Medically Managed Intensive Inpatient Withdrawal Management</b></td>
                        <td className='w-150'><b>4-WM</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_4Dimension_1None' name='rbCriteria_4Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_1Mild' name='rbCriteria_4Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_1Mod' name='rbCriteria_4Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_1Sev' name='rbCriteria_4Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_4Dimension_2None' name='rbCriteria_4Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_2Mild' name='rbCriteria_4Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_2Mod' name='rbCriteria_4Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_2Sev' name='rbCriteria_4Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_4Dimension_3None' name='rbCriteria_4Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_3Mild' name='rbCriteria_4Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_3Mod' name='rbCriteria_4Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_3Sev' name='rbCriteria_4Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_4Dimension_4None' name='rbCriteria_4Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_4Mild' name='rbCriteria_4Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_4Mod' name='rbCriteria_4Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_4Sev' name='rbCriteria_4Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_4Dimension_5None' name='rbCriteria_4Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_5Mild' name='rbCriteria_4Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_5Mod' name='rbCriteria_4Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_5Sev' name='rbCriteria_4Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteria_4Dimension_6None' name='rbCriteria_4Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_6Mild' name='rbCriteria_4Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_6Mod' name='rbCriteria_4Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteria_4Dimension_6Sev' name='rbCriteria_4Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>



                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Early Intervention</b></td>
                        <td className='w-150'><b>0.5</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_1None' name='rbCriteriaRecovery_05Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_1Mild' name='rbCriteriaRecovery_05Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_1Mod' name='rbCriteriaRecovery_05Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_1Sev' name='rbCriteriaRecovery_05Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_2None' name='rbCriteriaRecovery_05Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_2Mild' name='rbCriteriaRecovery_05Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_2Mod' name='rbCriteriaRecovery_05Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_2Sev' name='rbCriteriaRecovery_05Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_3None' name='rbCriteriaRecovery_05Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_3Mild' name='rbCriteriaRecovery_05Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_3Mod' name='rbCriteriaRecovery_05Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_3Sev' name='rbCriteriaRecovery_05Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_4None' name='rbCriteriaRecovery_05Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_4Mild' name='rbCriteriaRecovery_05Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_4Mod' name='rbCriteriaRecovery_05Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_4Sev' name='rbCriteriaRecovery_05Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_5None' name='rbCriteriaRecovery_05Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_5Mild' name='rbCriteriaRecovery_05Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_5Mod' name='rbCriteriaRecovery_05Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_5Sev' name='rbCriteriaRecovery_05Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_6None' name='rbCriteriaRecovery_05Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_6Mild' name='rbCriteriaRecovery_05Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_6Mod' name='rbCriteriaRecovery_05Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_05Dimension_6Sev' name='rbCriteriaRecovery_05Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Outpatient Services</b></td>
                        <td className='w-150'><b>1</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_1None' name='rbCriteriaRecovery_1Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_1Mild' name='rbCriteriaRecovery_1Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_1Mod' name='rbCriteriaRecovery_1Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_1Sev' name='rbCriteriaRecovery_1Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_2None' name='rbCriteriaRecovery_1Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_2Mild' name='rbCriteriaRecovery_1Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_2Mod' name='rbCriteriaRecovery_1Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_2Sev' name='rbCriteriaRecovery_1Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_3None' name='rbCriteriaRecovery_1Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_3Mild' name='rbCriteriaRecovery_1Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_3Mod' name='rbCriteriaRecovery_1Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_3Sev' name='rbCriteriaRecovery_1Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_4None' name='rbCriteriaRecovery_1Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_4Mild' name='rbCriteriaRecovery_1Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_4Mod' name='rbCriteriaRecovery_1Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_4Sev' name='rbCriteriaRecovery_1Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_5None' name='rbCriteriaRecovery_1Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_5Mild' name='rbCriteriaRecovery_1Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_5Mod' name='rbCriteriaRecovery_1Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_5Sev' name='rbCriteriaRecovery_1Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_6None' name='rbCriteriaRecovery_1Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_6Mild' name='rbCriteriaRecovery_1Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_6Mod' name='rbCriteriaRecovery_1Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_1Dimension_6Sev' name='rbCriteriaRecovery_1Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Intensive Outpatient Services </b></td>
                        <td className='w-150'><b>2.1</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_1None' name='rbCriteriaRecovery_21Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_1Mild' name='rbCriteriaRecovery_21Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_1Mod' name='rbCriteriaRecovery_21Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_1Sev' name='rbCriteriaRecovery_21Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_2None' name='rbCriteriaRecovery_21Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_2Mild' name='rbCriteriaRecovery_21Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_2Mod' name='rbCriteriaRecovery_21Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_2Sev' name='rbCriteriaRecovery_21Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_3None' name='rbCriteriaRecovery_21Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_3Mild' name='rbCriteriaRecovery_21Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_3Mod' name='rbCriteriaRecovery_21Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_3Sev' name='rbCriteriaRecovery_21Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_4None' name='rbCriteriaRecovery_21Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_4Mild' name='rbCriteriaRecovery_21Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_4Mod' name='rbCriteriaRecovery_21Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_4Sev' name='rbCriteriaRecovery_21Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_5None' name='rbCriteriaRecovery_21Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_5Mild' name='rbCriteriaRecovery_21Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_5Mod' name='rbCriteriaRecovery_21Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_5Sev' name='rbCriteriaRecovery_21Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_6None' name='rbCriteriaRecovery_21Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_6Mild' name='rbCriteriaRecovery_21Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_6Mod' name='rbCriteriaRecovery_21Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_21Dimension_6Sev' name='rbCriteriaRecovery_21Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Partial Hospitalization Services</b></td>
                        <td className='w-150'><b>2.5</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_1None' name='rbCriteriaRecovery_25Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_1Mild' name='rbCriteriaRecovery_25Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_1Mod' name='rbCriteriaRecovery_25Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_1Sev' name='rbCriteriaRecovery_25Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_2None' name='rbCriteriaRecovery_25Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_2Mild' name='rbCriteriaRecovery_25Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_2Mod' name='rbCriteriaRecovery_25Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_2Sev' name='rbCriteriaRecovery_25Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_3None' name='rbCriteriaRecovery_25Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_3Mild' name='rbCriteriaRecovery_25Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_3Mod' name='rbCriteriaRecovery_25Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_3Sev' name='rbCriteriaRecovery_25Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_4None' name='rbCriteriaRecovery_25Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_4Mild' name='rbCriteriaRecovery_25Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_4Mod' name='rbCriteriaRecovery_25Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_4Sev' name='rbCriteriaRecovery_25Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_5None' name='rbCriteriaRecovery_25Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_5Mild' name='rbCriteriaRecovery_25Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_5Mod' name='rbCriteriaRecovery_25Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_5Sev' name='rbCriteriaRecovery_25Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_6None' name='rbCriteriaRecovery_25Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_6Mild' name='rbCriteriaRecovery_25Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_6Mod' name='rbCriteriaRecovery_25Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_25Dimension_6Sev' name='rbCriteriaRecovery_25Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Clinically Managed Low-Intensity Residential Services</b></td>
                        <td className='w-150'><b>3.1</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_1None' name='rbCriteriaRecovery_31Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_1Mild' name='rbCriteriaRecovery_31Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_1Mod' name='rbCriteriaRecovery_31Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_1Sev' name='rbCriteriaRecovery_31Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_2None' name='rbCriteriaRecovery_31Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_2Mild' name='rbCriteriaRecovery_31Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_2Mod' name='rbCriteriaRecovery_31Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_2Sev' name='rbCriteriaRecovery_31Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_3None' name='rbCriteriaRecovery_31Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_3Mild' name='rbCriteriaRecovery_31Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_3Mod' name='rbCriteriaRecovery_31Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_3Sev' name='rbCriteriaRecovery_31Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_4None' name='rbCriteriaRecovery_31Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_4Mild' name='rbCriteriaRecovery_31Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_4Mod' name='rbCriteriaRecovery_31Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_4Sev' name='rbCriteriaRecovery_31Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_5None' name='rbCriteriaRecovery_31Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_5Mild' name='rbCriteriaRecovery_31Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_5Mod' name='rbCriteriaRecovery_31Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_5Sev' name='rbCriteriaRecovery_31Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_6None' name='rbCriteriaRecovery_31Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_6Mild' name='rbCriteriaRecovery_31Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_6Mod' name='rbCriteriaRecovery_31Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_31Dimension_6Sev' name='rbCriteriaRecovery_31Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Clinically Managed Population-Specific High-Intensity Residential Services</b></td>
                        <td className='w-150'><b>3.3</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_1None' name='rbCriteriaRecovery_33Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_1Mild' name='rbCriteriaRecovery_33Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_1Mod' name='rbCriteriaRecovery_33Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_1Sev' name='rbCriteriaRecovery_33Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_2None' name='rbCriteriaRecovery_33Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_2Mild' name='rbCriteriaRecovery_33Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_2Mod' name='rbCriteriaRecovery_33Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_2Sev' name='rbCriteriaRecovery_33Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_3None' name='rbCriteriaRecovery_33Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_3Mild' name='rbCriteriaRecovery_33Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_3Mod' name='rbCriteriaRecovery_33Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_3Sev' name='rbCriteriaRecovery_33Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_4None' name='rbCriteriaRecovery_33Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_4Mild' name='rbCriteriaRecovery_33Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_4Mod' name='rbCriteriaRecovery_33Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_4Sev' name='rbCriteriaRecovery_33Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_5None' name='rbCriteriaRecovery_33Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_5Mild' name='rbCriteriaRecovery_33Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_5Mod' name='rbCriteriaRecovery_33Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_5Sev' name='rbCriteriaRecovery_33Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_6None' name='rbCriteriaRecovery_33Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_6Mild' name='rbCriteriaRecovery_33Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_6Mod' name='rbCriteriaRecovery_33Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_33Dimension_6Sev' name='rbCriteriaRecovery_33Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Clinically Managed High-Intensity Residential Services</b></td>
                        <td className='w-150'><b>3.5</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_1None' name='rbCriteriaRecovery_35Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_1Mild' name='rbCriteriaRecovery_35Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_1Mod' name='rbCriteriaRecovery_35Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_1Sev' name='rbCriteriaRecovery_35Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_2None' name='rbCriteriaRecovery_35Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_2Mild' name='rbCriteriaRecovery_35Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_2Mod' name='rbCriteriaRecovery_35Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_2Sev' name='rbCriteriaRecovery_35Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_3None' name='rbCriteriaRecovery_35Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_3Mild' name='rbCriteriaRecovery_35Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_3Mod' name='rbCriteriaRecovery_35Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_3Sev' name='rbCriteriaRecovery_35Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_4None' name='rbCriteriaRecovery_35Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_4Mild' name='rbCriteriaRecovery_35Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_4Mod' name='rbCriteriaRecovery_35Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_4Sev' name='rbCriteriaRecovery_35Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_5None' name='rbCriteriaRecovery_35Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_5Mild' name='rbCriteriaRecovery_35Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_5Mod' name='rbCriteriaRecovery_35Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_5Sev' name='rbCriteriaRecovery_35Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_6None' name='rbCriteriaRecovery_35Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_6Mild' name='rbCriteriaRecovery_35Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_6Mod' name='rbCriteriaRecovery_35Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_35Dimension_6Sev' name='rbCriteriaRecovery_35Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Medically Monitored Intensive Inpatient Services </b></td>
                        <td className='w-150'><b>3.7</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_1None' name='rbCriteriaRecovery_37Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_1Mild' name='rbCriteriaRecovery_37Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_1Mod' name='rbCriteriaRecovery_37Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_1Sev' name='rbCriteriaRecovery_37Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_2None' name='rbCriteriaRecovery_37Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_2Mild' name='rbCriteriaRecovery_37Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_2Mod' name='rbCriteriaRecovery_37Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_2Sev' name='rbCriteriaRecovery_37Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_3None' name='rbCriteriaRecovery_37Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_3Mild' name='rbCriteriaRecovery_37Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_3Mod' name='rbCriteriaRecovery_37Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_3Sev' name='rbCriteriaRecovery_37Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_4None' name='rbCriteriaRecovery_37Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_4Mild' name='rbCriteriaRecovery_37Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_4Mod' name='rbCriteriaRecovery_37Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_4Sev' name='rbCriteriaRecovery_37Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_5None' name='rbCriteriaRecovery_37Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_5Mild' name='rbCriteriaRecovery_37Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_5Mod' name='rbCriteriaRecovery_37Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_5Sev' name='rbCriteriaRecovery_37Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_6None' name='rbCriteriaRecovery_37Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_6Mild' name='rbCriteriaRecovery_37Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_6Mod' name='rbCriteriaRecovery_37Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_37Dimension_6Sev' name='rbCriteriaRecovery_37Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Medically Managed Intensive Inpatient Services </b></td>
                        <td className='w-150'><b>4</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_1None' name='rbCriteriaRecovery_4Dimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_1Mild' name='rbCriteriaRecovery_4Dimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_1Mod' name='rbCriteriaRecovery_4Dimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_1Sev' name='rbCriteriaRecovery_4Dimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_2None' name='rbCriteriaRecovery_4Dimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_2Mild' name='rbCriteriaRecovery_4Dimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_2Mod' name='rbCriteriaRecovery_4Dimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_2Sev' name='rbCriteriaRecovery_4Dimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_3None' name='rbCriteriaRecovery_4Dimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_3Mild' name='rbCriteriaRecovery_4Dimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_3Mod' name='rbCriteriaRecovery_4Dimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_3Sev' name='rbCriteriaRecovery_4Dimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_4None' name='rbCriteriaRecovery_4Dimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_4Mild' name='rbCriteriaRecovery_4Dimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_4Mod' name='rbCriteriaRecovery_4Dimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_4Sev' name='rbCriteriaRecovery_4Dimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_5None' name='rbCriteriaRecovery_4Dimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_5Mild' name='rbCriteriaRecovery_4Dimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_5Mod' name='rbCriteriaRecovery_4Dimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_5Sev' name='rbCriteriaRecovery_4Dimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_6None' name='rbCriteriaRecovery_4Dimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_6Mild' name='rbCriteriaRecovery_4Dimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_6Mod' name='rbCriteriaRecovery_4Dimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaRecovery_4Dimension_6Sev' name='rbCriteriaRecovery_4Dimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-600'><span className='eleHeader'>ASAM Criteria Level of Care- Other Treatment and Recovery Services</span></td>
                        <td className='w-150'><span className='eleHeader'>ASAM Level</span></td>
                    </tr>
                    <tr>
                        <td className='w-600'><b>Opioid Treatment Program</b></td>
                        <td className='w-150'><b>OTP</b></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 1</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 2</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 3</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaOtpDimension_1None' name='rbCriteriaOtpDimension_1' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_1Mild' name='rbCriteriaOtpDimension_1' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_1Mod' name='rbCriteriaOtpDimension_1' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_1Sev' name='rbCriteriaOtpDimension_1' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaOtpDimension_2None' name='rbCriteriaOtpDimension_2' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_2Mild' name='rbCriteriaOtpDimension_2' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_2Mod' name='rbCriteriaOtpDimension_2' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_2Sev' name='rbCriteriaOtpDimension_2' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaOtpDimension_3None' name='rbCriteriaOtpDimension_3' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_3Mild' name='rbCriteriaOtpDimension_3' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_3Mod' name='rbCriteriaOtpDimension_3' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_3Sev' name='rbCriteriaOtpDimension_3' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'><span className='eleHeader'>Dimension 4</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 5</span></td>
                        <td className='w-250'><span className='eleHeader'>Dimension 6</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaOtpDimension_4None' name='rbCriteriaOtpDimension_4' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_4Mild' name='rbCriteriaOtpDimension_4' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_4Mod' name='rbCriteriaOtpDimension_4' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_4Sev' name='rbCriteriaOtpDimension_4' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaOtpDimension_5None' name='rbCriteriaOtpDimension_5' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_5Mild' name='rbCriteriaOtpDimension_5' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_5Mod' name='rbCriteriaOtpDimension_5' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_5Sev' name='rbCriteriaOtpDimension_5' className='add-only' value='Sev' /> Sev
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbCriteriaOtpDimension_6None' name='rbCriteriaOtpDimension_6' className='add-only' value='None' /> None &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_6Mild' name='rbCriteriaOtpDimension_6' className='add-only' value='Mild' /> Mild &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_6Mod' name='rbCriteriaOtpDimension_6' className='add-only' value='Mod' /> Mod &nbsp;
                            <input type='radio' id='rbCriteriaOtpDimension_6Sev' name='rbCriteriaOtpDimension_6' className='add-only' value='Sev' /> Sev
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Would the patient with alcohol or opioid use disorders benefit from and be interested in Medication-Assisted Treatment (MAT)?</span></p>
                <p className='w-750'>
                    <input type='radio' id='rbMatYes' name='rbMat' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMatNo' name='rbMat' className='add-only' value='No' /> No
                </p>
                <p className='w-750'><span className='eleHeader'>Please describe : </span></p>
                <p className='w-750'>
                    <input type='text' id='txtMatDescribe' name='txtMatDescribe' className='add-only' />
                </p>

                <p className='w-750'><h3>Placement Summary</h3></p>
                <p className='w-750'><b>Level of Care: </b> Enter the ASAM Level of Care (e.g., 3.1, 2.1, 3.2, W.M) number that offers the most appropriate treatment setting given the patient's current severity and functioning:</p>
                <p className='w-750'><input type='text' id='txtPlacementSummary' name='txtPlacementSummary' className='add-only w-150 custom-add-only' /></p>
                <p className='w-750'><b>Level of Care Provided:</b> Enter the ASAM Level of Care (e.g., 3.1, 2.1, 3.2, W.M) number that offers the most appropriate treatment setting given the patient's current severity and functioning:</p>
                <p className='w-750'><input type='text' id='txtCareProvided' name='txtCareProvided' className='add-only w-150 custom-add-only' /></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Reason for Discrepancy</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyNotApplicable' name='cbDiscrepancyNotApplicable' className='add-only' value='NotApplicable' /> Not Applicable</td>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyServiceNotAvailable' name='cbDiscrepancyServiceNotAvailable' className='add-only' value='ServiceNotAvailableServiceNotAvailable' /> Service Not Available</td>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyProviderJudgment' name='cbDiscrepancyProviderJudgment' className='add-only' value='ProviderJudgment' /> Provider Judgment</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyPatientPreference' name='cbDiscrepancyPatientPreference' className='add-only' value='PatientPreference' /> Patient Preference</td>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyTransportation' name='cbDiscrepancyTransportation' className='add-only' value='Transportation' /> Transportation</td>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyAccessibility' name='cbDiscrepancyAccessibility' className='add-only' value='Accessibility' /> Accessibility</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyFinancial' name='cbDiscrepancyFinancial' className='add-only' value='Financial' /> Financial</td>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyPreferredWait' name='cbDiscrepancyPreferredWait' className='add-only' value='PreferredWait' /> Preferred to Wait</td>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyEnvironment' name='cbDiscrepancyEnvironment' className='add-only' value='Environment' /> Environment</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyMentalHealth' name='cbDiscrepancyMentalHealth' className='add-only' value='MentalHealth' /> Mental Health</td>
                        <td className='w-250'><input type='checkbox' id='cbDiscrepancyPhysicalHealth' name='cbDiscrepancyPhysicalHealth' className='add-only' value='PhysicalHealth' /> Physical Health</td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='checkbox' id='cbDiscrepancyCulturalConsiderations' name='cbDiscrepancyCulturalConsiderations' className='add-only' value='CulturalConsiderations' /> Language/ Cultural Considerations</td>
                    </tr>


                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbDiscrepancyOther' name='cbDiscrepancyOther' className='add-only' value='Other' /> Other: &nbsp;
                            <input type='text' id='txtDiscrepancyOther' name='txtDiscrepancyOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>

                </table>

                <p className='w-750'><span className='eleHeader'>Briefly Explain Discrepancy</span></p>
                <p className='w-750'>
                    <textarea id='txtExplainDiscrepancy' name='txtExplainDiscrepancy' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Designated Treatment Location and Provider Name</span></p>
                <p className='w-750'>
                    <textarea id='txtDesignatedTreatmentLocation' name='txtDesignatedTreatmentLocation' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-325'></td>
                        <td className='signature w-250'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-325'> &nbsp;Counselor Name (if applicable) &nbsp;</td>
                        <td className='small w-250'> &nbsp;Signature</td>
                        <td className='small w-150'> &nbsp;Date</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-325'></td>
                        <td className='signature w-250'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-325'> &nbsp;Licensed-eligible LMHP Name (if applicable)</td>
                        <td className='small w-250'> &nbsp;Signature</td>
                        <td className='small w-150'> &nbsp;Date</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-325'></td>
                        <td className='signature w-250'></td>
                        <td className='signature w-150'></td>
                    </tr>
                    <tr>
                        <td className='small w-325'> &nbsp;Licensed LMHP Name</td>
                        <td className='small w-250'> &nbsp;Signature</td>
                        <td className='small w-150'> &nbsp;Date</td>
                    </tr>
                </table>


            </div>
        </form>

    )
}







